const put = `**Method:** \`PUT\`

**Headers:**
* *Authorization*: [YES](https://docs.ipfabric.io/main/api/#header-authentication)
* *Content-Type*: \`application/json\`

**Payload**:

A JSON object with the following properties:
* \`attributes\` (required): array of objects with following properties:
  * \`name\` (required): string
  * \`sn\` (required): string
  * \`value\` (required): string | boolean | number
`;

const del = `**Method:** \`DELETE\`

**Headers:**
* *Authorization*: [YES](https://docs.ipfabric.io/main/api/#header-authentication)
* *Content-Type*: \`application/json\`

**Payload**:

A JSON object with the following properties:
  * \`attributes\` (required): one of following objects:
    * by id:
      * \`id\` (required): array of strings
    * by sn or name (one is required)
      * \`sn\` (required): array of strings
      * \`name\` (required): array of strings
`;

export const deviceAttributesDocs = {
  put,
  delete: del,
};
